export type Realm = "local" | "dev" | "stage" | "prod";

export enum TagType {
  chat = "sendgrid_support_email_chat",
  requestPhoneCallback = "sendgrid_support_all_options",
  supportRequest = "sendgrid_support_email",
}

export interface User {
  email: string;
  identifier: string;
  name: string;
  role?: string;
  tags: TagType[];
  avatarUrl?: string;
  groups?: string[];
  is_admin?: boolean;
  locale?: string;
  organizations?: string[];
}

export enum ConfigLogLevel {
  debug = "debug",
  info = "info",
}

export enum BrandEnum {
  sendGrid = "sendGrid",
  twilio = "twilio",
}

export enum SearchIndexEnum {
  sendGrid = "sghc",
}

export enum Realms {
  local = "local",
  dev = "dev",
  stage = "stage",
  prod = "prod",
}

// Copied over from form_controller.coffee
export enum EmailSupportPackage {
  "lite" = "sg_pkg_lite",
  "reseller" = "sg_pkg_reseller",
  "highVolume" = "sg_pkg_hv",
  "free" = "sg_email_pkg_free",
  "essentials" = "sg_email_pkg_essentials",
  "pro" = "sg_email_pkg_pro",
  "premier" = "sg_email_pkg_premier", // Everything below is considered legacy, but we will keep it here.
  // "Trial" : "package_ei_trial"
  // "Essentials" : "package_ei_essentials"
  // "Pro" : "package_ei_pro"
  // "Premier" : "package_ei_premier"
  // "Custom" : "package_ei_custom"
  // "Not an Email API Customer" : "package_no_ei"
}

// Copied over from form_controller.coffee
export enum MarketingSupportPackage {
  "free" = "sg_mktg_pkg_free",
  "basic" = "sg_mktg_pkg_basic",
  "enterprise" = "sg_mktg_pkg_advanced", // Everything below is considered legacy, but we will keep it here.
  "custom" = "sg_mktg_pkg_advanced",
  // "Advanced" : "package_mc_advanced",
  // "Custom" : "sg_mktg_pkg_advanced",
  // "Not an MC Customer" : "package_no_mc"
}

export interface SendGridUserValues {
  userId: string;
  username: string;
  supportPackage: {
    emailSupportPackage: EmailSupportPackage;
    marketingSupportPackage: MarketingSupportPackage;
  };
}

export type Config = Record<Realm, Record<string, string | number>>;
